import { Upload } from "antd";
import { UNLIMITED } from "../config/uploadLimits";

export const getImageUploadLimitState = (currentCount = 0, limit = UNLIMITED) => {
  const isUnlimited = limit === UNLIMITED;

  return {
    isUnlimited,
    canUploadMore: isUnlimited || currentCount < limit,
    limitLabel: isUnlimited ? "" : `(Max: ${limit})`,
    // Edit* forms track images already persisted separately from the
    // in-session fileList — this is how many more of the overall cap
    // remain right now (their existing `10 - xImages.length` shape).
    remainingSlots: isUnlimited ? undefined : Math.max(0, limit - currentCount),
    // New* forms' fileList IS the whole list — hand this straight to
    // antd's Upload maxCount (undefined disables antd's own cap).
    flatMaxCount: isUnlimited ? undefined : limit,
  };
};

// Builds an antd `beforeUpload(file, batchFileList)` that actually blocks
// uploads past `limit` — maxCount alone does not: it only truncates antd's
// displayed fileList after the underlying request has already fired (see
// rc-upload's AjaxUploader.uploadFiles, which calls post() for every file
// beforeUpload doesn't reject, independent of maxCount). `batchFileList`
// is the files selected in this one pick/drop action; indexInBatch lets a
// single multi-file selection that would overshoot the limit accept only
// as many as still fit, rejecting the rest — a plain "currentCount <
// limit" check would wrongly accept every file in the batch, since none
// of their beforeUpload calls see each other's effect on the count.
export const createLimitedBeforeUpload = ({
  getCurrentCount,
  limit,
  onLimitExceeded,
  acceptResult, // pass `false` for forms that defer the real upload to form-submit
}) => (file, batchFileList) => {
  if (limit === UNLIMITED) return acceptResult;

  const remaining = Math.max(0, limit - getCurrentCount());
  const indexInBatch = batchFileList.indexOf(file);

  if (indexInBatch < remaining) return acceptResult;

  // Only the first file that tips this batch over the limit notifies —
  // antd calls beforeUpload once per selected file, so without this guard
  // a single over-limit multi-select fires one toast per rejected file.
  if (indexInBatch === remaining) onLimitExceeded?.();
  return Upload.LIST_IGNORE;
};
